import React from "react";
import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import "./app.css";
import { LangCtx, LANGS, useT, useLang } from "./i18n";
import { PAGES, parsePath, pageUrl, useSeo } from "./seo";
import { ShopProvider, CallButton, Socials } from "./component/shop";
import Home from "./pages/home/home";
import Catalog from "./pages/catalog/catalog";

// Язык и страница берутся из адреса: /iphone — русский, /uz/iphone — узбекский, /kaa/iphone — каракалпакский
const Header = ({ pageKey }) => {
    const t = useT();
    const { lang, setLang } = useLang();
    const on = (keys) => (keys.includes(pageKey) ? "on" : "");
    return (
        <header className="hdr">
            <div className="wrap">
                <Link className="logo" to={pageUrl(lang, "home")} aria-label="TELE STORE"><img src="/logo.png" alt="TELE STORE" /></Link>
                <nav className="mnav" aria-label="menu">
                    <Link to={pageUrl(lang, "home")} className={on(["home"])}>{t("nav_home")}</Link>
                    <Link to={pageUrl(lang, "catalog")} className={on(["catalog", "iphone", "samsung", "xiaomi"])}>{t("nav_catalog")}</Link>
                    <Link to={pageUrl(lang, "credit")} className={on(["credit"])}>{t("nav_credit")}</Link>
                    <Link to={pageUrl(lang, "contacts")} className={on(["contacts"])}>{t("nav_contacts")}</Link>
                </nav>
                <div className="hdr-r">
                    <div className="lang" role="group" aria-label="Language">
                        {LANGS.map(([k, l]) => <button key={k} className={lang === k ? "on" : ""} onClick={() => setLang(k)}>{l}</button>)}
                    </div>
                    <CallButton className="btn sm call-top"><span>+998 77 116 70 00</span></CallButton>
                </div>
            </div>
        </header>
    );
};

const App = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { lang, key } = parsePath(location.pathname);
    // Переключатель языка ведёт на ту же страницу на другом языке
    const setLang = (l) => navigate(pageUrl(l, key || "home"));
    return (
        <LangCtx.Provider value={{ lang, setLang }}>
            <ShopProvider>
                {key ? <Shell pageKey={key} /> : <Navigate to={pageUrl(lang, "home")} replace />}
            </ShopProvider>
        </LangCtx.Provider>
    );
};

const Shell = ({ pageKey }) => {
    const t = useT();
    const { lang } = useLang();
    useSeo(lang, pageKey);
    const isCatalog = PAGES[pageKey].view === "catalog";
    return (
        <>
            <Header pageKey={pageKey} />
            {isCatalog ? <Catalog key={pageKey} pageKey={pageKey} /> : <Home pageKey={pageKey} />}
            <footer className="ftr"><div className="wrap"><span>© {new Date().getFullYear()} TELE STORE · {t("addr")}</span><Socials /></div></footer>
            <div className="callbar"><Link className="btn ghost" to={pageUrl(lang, "catalog")}>{t("nav_catalog")}</Link><CallButton /></div>
        </>
    );
};

export default App;
